var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"start","font-weight":"bold"}},[(!_vm.isSubscribed)?_c('div',[_vm._v("\n    Welcome to "+_vm._s(_vm.name)+"!\n  ")]):_c('div',[_vm._v("\n    Welcome back to "+_vm._s(_vm.name)+"!\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }